/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
    Analysisdata : null,
};


const reducer = (state = initialState, action = {}) => {

  switch (action.type) {
    
    case actions.checkSummaryActions.REQUEST_CHECK_SUMMARY:
      return {
        ...state,
    };
    case actions.checkSummaryActions.CHECK_SUMMARY_RECEIVED:

          return{
      ...state,
      Analysisdata: action?.data?.Analysisdata,
      InterviewComplete: action?.data?.InterviewComplete
    };

    default:
      return state;
  }
};

export default reducer;
